import React from "react";
import styled from "styled-components";
import { FiArrowUpRight, FiAward } from "react-icons/fi";
import { certificateName } from "./certificateData";

const CertificateCard = ({ certificate, onOpen }) => (
  <Card>
    <button type="button" aria-label={`View ${certificateName(certificate)} certificate`} onClick={onOpen}>
      <Preview>
        <img src={certificate.image} alt="" width={certificate.imageWidth} height={certificate.imageHeight} loading="lazy" decoding="async" />
        <Expand aria-hidden="true"><FiArrowUpRight /></Expand>
      </Preview>
      <Details>
        <Meta><span>{certificate.category}</span><span>{certificate.level}</span></Meta>
        <Title>{certificate.title}</Title>
        <CardFooter><span><FiAward aria-hidden="true" /> {certificate.issuer}</span><span>View certificate <FiArrowUpRight aria-hidden="true" /></span></CardFooter>
      </Details>
    </button>
  </Card>
);

export default CertificateCard;

const Card = styled.article`
  min-width: 0;
  border: 1px solid #dbe6de;
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: 0 4px 16px #183c3204;
  transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;

  > button {
    display: flex; flex-direction: column; width: 100%; height: 100%;
    padding: 0; border: 0; border-radius: inherit; background: transparent; text-align: left; color: inherit; cursor: pointer;
    &:focus-visible { outline: 2px solid #008369; outline-offset: 4px; }
  }

  @media (hover: hover) {
    &:hover { transform: translateY(-4px); border-color: #a8c9b4; box-shadow: 0 14px 30px #183c3210; }
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:hover { transform: none; }
  }
`;
const Preview = styled.span`
  display: block; position: relative; width: 100%; padding: 1.25rem 1.25rem 0;
  border-radius: 1.25rem 1.25rem 0 0;
  background: linear-gradient(150deg, #edf5ef, #f6f8f5);
  img { display: block; width: 100%; height: auto; aspect-ratio: 3308 / 2520; object-fit: contain; box-shadow: 0 2px 12px #183c320b; }
`;
const Expand = styled.span`
  position: absolute; right: 0.75rem; top: 0.75rem;
  display: grid; place-items: center; width: 2rem; height: 2rem; border-radius: 50%;
  background: #183c32; color: #fff; box-shadow: 0 3px 8px #183c321a;
`;
const Details = styled.span`display: flex; flex-direction: column; flex: 1; width: 100%; padding: 1.25rem;`;
const Meta = styled.span`
  display: flex; justify-content: space-between; flex-wrap: wrap; gap: 0.5rem;
  color: #64756a; font-size: 0.65rem; line-height: 1.6;
  span:last-child { color: #007b61; }
`;
const Title = styled.strong`display: block; margin: 0.65rem 0 1.25rem; color: #253d31; font-size: 1rem; font-weight: 600; line-height: 1.5; letter-spacing: -0.025em;`;
const CardFooter = styled.span`
  display: flex; justify-content: space-between; flex-wrap: wrap; gap: 0.5rem;
  margin-top: auto; padding-top: 1rem; border-top: 1px solid #e7eee9;
  color: #65736b; font-size: 0.65rem; line-height: 1.6;
  > span { display: inline-flex; align-items: center; gap: 0.35rem; }
  > span:last-child { color: #007b61; font-weight: 500; }
`;
